import { AnalyticsProvider } from './AnalyticsProvider';

export const GA_CONNECTOR_SCRIPT_ID = 'ga-connector';
export const GA_CONNECTOR_READY_EVENT = 'jhtGAConnectorReady';
export const DEFAULT_GA_CONNECTOR_URL =
  'https://track.gaconnector.com/gaconnector.js';

export class GAConnectorProvider implements AnalyticsProvider {
  name = 'ga-connector';

  initialize(): void {
    if (document.getElementById(GA_CONNECTOR_SCRIPT_ID)) {
      return;
    }

    const gaScript = document.createElement('script');
    gaScript.id = GA_CONNECTOR_SCRIPT_ID;
    gaScript.src =
      process.env.REACT_APP_GA_CONNECTOR_URL || DEFAULT_GA_CONNECTOR_URL;
    // Cookiebot manual blocking: inert until statistics consent.
    gaScript.type = 'text/plain';
    gaScript.setAttribute('data-cookieconsent', 'statistics');
    gaScript.onload = () => {
      console.log('GA Connector loaded');
      window.dispatchEvent(new Event(GA_CONNECTOR_READY_EVENT));
    };
    gaScript.onerror = () => console.error('GA Connector failed to load');
    document.head.appendChild(gaScript);

    // If GTM already ran Cookiebot, pick up this late-inserted tag.
    window.Cookiebot?.runScripts?.();
  }

  track(event: string, properties?: Record<string, any>): void {
    // GA Connector doesn't have direct tracking methods
    console.log('GA Connector track:', event, properties);
  }

  identify(userId: string, traits?: Record<string, any>): void {
    // GA Connector doesn't have direct identify methods
    console.log('GA Connector identify:', userId, traits);
  }

  page(name?: string, properties?: Record<string, any>): void {
    // GA Connector doesn't have direct page methods
    console.log('GA Connector page:', name, properties);
  }
}
